import { render, staticRenderFns } from "./NewIndex.vue?vue&type=template&id=0a4e6ab2&scoped=true"
import script from "./NewIndex.vue?vue&type=script&lang=ts"
export * from "./NewIndex.vue?vue&type=script&lang=ts"
import style0 from "./NewIndex.vue?vue&type=style&index=0&id=0a4e6ab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e6ab2",
  null
  
)

export default component.exports